import { Component } from '@angular/core';
import { Routes } from '@angular/router';

import { accountRoutes } from '@modules/account/account.routes';
import { billingRoutes } from '@modules/billing/billing.routes';
import { calendarRoutes } from '@modules/calendar/calendar.routes';
import { cecRoutes } from '@modules/cec/cec.routes';
import { communityRoutes } from '@modules/community/community.routes';
import { finmaRoutes } from '@modules/finma/finma.routes';
import { homeRoutes } from '@modules/home/home.routes';
import { messagesRoutes } from '@modules/messages/messages.routes';
import { priceCalculatorRoutes } from '@modules/price-calculator/price-calculator.routes';
import { recentRoutes } from '@modules/recent/recent.routes';
import { reportingRoutes } from '@modules/reporting/reporting.routes';
import { roomsRoutes } from '@modules/rooms/rooms.routes';
import { searchRoutes } from '@modules/search/search.routes';
import { sharedWithMeRoutes } from '@modules/shared-with-me/shared-with-me.routes';
import { signingRoutes } from '@modules/signing/signing.routes';

import { appResolver } from './app.resolver';
import { NotFoundComponent } from './core/components/404.component';
import { ServiceUnavailableComponent } from './core/components/503.component';
import {
  i18nResolver,
  storedLocaleResolver,
  userBeanResolver,
} from './core/resolvers';

@Component({
  selector: 'app-empty',
  template: '',
})
export class EmptyComponent {}

export const routes: Routes = [
  ...accountRoutes,
  ...billingRoutes,
  ...calendarRoutes,
  ...cecRoutes,
  ...communityRoutes,
  ...finmaRoutes,
  ...homeRoutes,
  ...messagesRoutes,
  ...priceCalculatorRoutes,
  ...recentRoutes,
  ...reportingRoutes,
  ...roomsRoutes,
  ...searchRoutes,
  ...sharedWithMeRoutes,
  ...signingRoutes,
  {
    path: '',
    resolve: { appData: appResolver },
    pathMatch: 'full',
    component: EmptyComponent,
  },
  {
    path: '404',
    title: 'WEB_404_TITLE',
    resolve: {
      agorai18n: i18nResolver,
      userBean: userBeanResolver,
    },
    component: NotFoundComponent,
  },
  {
    path: '503',
    title: 'WEB_503_TITLE',
    resolve: {
      agorai18n: storedLocaleResolver,
    },
    component: ServiceUnavailableComponent,
  },
  { path: '**', redirectTo: '/home', pathMatch: 'full' },
];
